module.exports = __webpack_public_path__ + "static/media/shops-share-badge.4cf4b66d.png";